import React from 'react';
import { useTranslation } from 'react-i18next';
import ExpandedListTab from '../ExpandedListTab';
import { cashLimitType } from '../../types';
import ReadonlyField from '../fields/ReadonlyField';
import ReadonlyNumberField from '../fields/ReadonlyNumberField';
import DateTime, { LONG_DATE } from '../DateTime';
import { getCashLimitCreator } from '../../utils/CashLimitCreators';
import { getCashLimitStatus } from '../../utils/CashLimitStatuses';

CashLimitDetailTab.propTypes = {
    cashLimit: cashLimitType.isRequired,
};

function CashLimitDetailTab(props) {
    const {
        cashLimit,
    } = props;
    const { t } = useTranslation();
    return (
        <ExpandedListTab
            className="cash-limit-detail-tab"
            title={t('cash-limits.cash-limit-detail')}
        >
            <div className="rich-list-row-expanded--fields">
                <ReadonlyField
                    label={t('cash-limits.main-id')}
                    value={cashLimit.mainId}
                    className="cash-limit-detail-tab--fields--main-id"
                />
                <ReadonlyField
                    label={t('cash-limits.member')}
                    value={`${cashLimit.member.memberId} (${cashLimit.member.name})`}
                    className="cash-limit-detail-tab--fields--member"
                />
                <ReadonlyNumberField
                    label={t('cash-limits.limit-value')}
                    value={cashLimit.limitValue}
                    fractionDigits={2}
                    className="cash-limit-detail-tab--fields--limit-value"
                />
                <ReadonlyField
                    label={t('cash-limits.begin-date')}
                    value={<DateTime value={cashLimit.beginDate} format={LONG_DATE} />}
                    className="cash-limit-detail-tab--fields--begin-date"
                />
                <ReadonlyField
                    label={t('cash-limits.end-date')}
                    value={<DateTime value={cashLimit.endDate} format={LONG_DATE} />}
                    className="cash-limit-detail-tab--fields--end-date"
                />
                <ReadonlyField
                    label={t('cash-limits.creator')}
                    value={getCashLimitCreator(cashLimit).transform(t)}
                    className="cash-limit-detail-tab--fields--creator"
                />
                <ReadonlyField
                    label={t('cash-limits.status')}
                    value={getCashLimitStatus(cashLimit.status).translate(t)}
                    className="cash-limit-detail-tab--fields--status"
                />
                <ReadonlyField
                    label={t('cash-limits.version')}
                    value={cashLimit.version}
                    className="cash-limit-detail-tab--fields--version"
                />
                <ReadonlyField
                    label={t('cash-limits.token')}
                    value={cashLimit.token}
                    className="cash-limit-detail-tab--fields--token"
                />
                <ReadonlyField
                    label={t('cash-limits.definition-description')}
                    value={cashLimit.definitionDescription}
                    className="cash-limit-detail-tab--fields--definition-description"
                    emptyValue={t('cash-limits.empty-value.definition-description')}
                />
                <ReadonlyField
                    label={t('cash-limits.custom-name')}
                    value={cashLimit.customName}
                    className="cash-limit-detail-tab--fields--custom-name"
                    emptyValue={t('cash-limits.empty-value.custom-name')}
                />
                <ReadonlyField
                    label={t('cash-limits.ccp')}
                    value={cashLimit.ccp}
                    className="cash-limit-detail-tab--fields--ccp"
                    emptyValue={t('cash-limits.empty-value.ccp')}
                />
                <ReadonlyField
                    label={t('cash-limits.tso')}
                    value={cashLimit.tso}
                    className="cash-limit-detail-tab--fields--tso"
                    emptyValue={t('cash-limits.empty-value.tso')}
                />
                <ReadonlyField
                    label={t('cash-limits.clearing-member')}
                    value={cashLimit.clearingMember}
                    className="cash-limit-detail-tab--fields--clearing-member"
                    emptyValue={t('cash-limits.empty-value.clearing-member')}
                />
            </div>
        </ExpandedListTab>
    );
}

export default CashLimitDetailTab;
